module.exports = __webpack_public_path__ + "static/emm-001-7ed8193ccda287099a3835c2f3fa10b9.jpg";